import { render } from "./LearnerLOSidebar.vue?vue&type=template&id=5bc73331"
import script from "./LearnerLOSidebar.vue?vue&type=script&lang=js"
export * from "./LearnerLOSidebar.vue?vue&type=script&lang=js"

import "./LearnerLOSidebar.vue?vue&type=style&index=0&id=5bc73331&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__